import { useMatchList } from "@/api/services/admin/match";
import { EMatchContractStatus } from "@/types/enum";
import { Stack } from "@mui/material";
import React, { FC } from "react";
import { CountTable } from "@/components/elements/CountTable";

type TMatchListTopProps = {
  contractStatuses: EMatchContractStatus[];
};

export const MatchListTop: FC<TMatchListTopProps> = ({ contractStatuses }) => {
  const { data } = useMatchList(contractStatuses);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <CountTable total={data?.pagination.total} page={data?.pagination.page} perPage={data?.pagination.perPage} />
    </Stack>
  );
};
